import {WineItem} from "../../../MenuDocumentModel";
import {EditorItem, getWineItemShowYear, useUpdateProperty} from "../../../editorUtils";
import React, {ReactElement} from "react";
import {useAppSelector} from "../../../../../lib/redux/hooks";
import {menuEditorSelectors} from "../../../editorSlice";
import {FormattedMessage} from "react-intl";
import {SliderToggle} from "../../../../../components/UIComponents/SliderToggle";


export interface ShowYearControlProps {
    wine: EditorItem<WineItem>;
}

export function ShowYearControl(props: ShowYearControlProps): ReactElement {
    const document = useAppSelector(menuEditorSelectors.document);
    const updateProperty = useUpdateProperty(props.wine);
    if (!document) return <></>;

    const wineItem = props.wine.menuItem;
    const showYear = getWineItemShowYear(wineItem, document);

    return <>
        <div className="flex items-center gap-2">
            <span className="flex-auto text-sm">
                <FormattedMessage id="editor.format.showYear"/>
            </span>
            <div className="flex-none h-7 w-12">
                <SliderToggle
                    enabled={showYear}
                    setEnabled={val => updateProperty('showYear', val)}
                />
            </div>
        </div>
    </>;
}